var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.00001H7.3C5.61984 4.00001 4.77976 4.00001 4.13803 4.32699C3.57354 4.61461 3.1146 5.07356 2.82698 5.63804C2.5 6.27978 2.5 7.11986 2.5 8.80001V17.2C2.5 18.8802 2.5 19.7203 2.82698 20.362C3.1146 20.9265 3.57354 21.3854 4.13803 21.673C4.77976 22 5.61984 22 7.3 22H15.7C17.3802 22 18.2202 22 18.862 21.673C19.4265 21.3854 19.8854 20.9265 20.173 20.362C20.5 19.7203 20.5 18.8802 20.5 17.2V13M8.49997 16H10.1745C10.6637 16 10.9083 16 11.1385 15.9448C11.3425 15.8958 11.5376 15.815 11.7166 15.7053C11.9184 15.5816 12.0914 15.4087 12.4373 15.0628L22 5.50001C22.8284 4.67159 22.8284 3.32844 22 2.50001C21.1716 1.67159 19.8284 1.67159 19 2.50001L9.43723 12.0628C9.09133 12.4087 8.91838 12.5816 8.79469 12.7834C8.68504 12.9624 8.60423 13.1575 8.55523 13.3616C8.49997 13.5917 8.49997 13.8363 8.49997 14.3255V16Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSettings);
export default __webpack_public_path__ + "static/media/edit-settings.6da6a724b34d20dda59d5cd244aad7cb.svg";
export { ForwardRef as ReactComponent };